import React from "react";
import classNames from "classnames";
import { ReportIndicators } from "@planzone/dto";
import { Props } from "./types";
import { VeryGoodIcon } from "./veryGoodIcon";
import { GoodIcon } from "./goodIcon";
import { MildIcon } from "./mildIcon";
import { BadIcon } from "./badIcon";
import { VeryBadIcon } from "./veryBadIcon";
import styles from "./styles.scss";

function ReportIndicator({ value, className }: Props) {
  const iconMap = {
    [ReportIndicators.VERY_GOOD]: VeryGoodIcon,
    [ReportIndicators.GOOD]: GoodIcon,
    [ReportIndicators.MILD]: MildIcon,
    [ReportIndicators.BAD]: BadIcon,
    [ReportIndicators.VERY_BAD]: VeryBadIcon,
  };
  const Icon = iconMap[value] || React.Fragment;

  return <Icon className={classNames(styles.indicator, className)} />;
}

export { ReportIndicator };
